"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSubCategoryOrLookBookLink = exports.isNotCategoryLink = exports.getWhatsNewAndAllCategory = exports.determineActiveCategory = void 0;
var _models = require("../../../models");
var _net = require("../../../models/graphql-types/net");
var _utils = require("../../../utils");
const isSubCategoryOrLookBookLink = linkType => linkType === _net.NavigationLinkType.SubCategory || linkType === _net.NavigationLinkType.PopularLookbook;
exports.isSubCategoryOrLookBookLink = isSubCategoryOrLookBookLink;
const isNotCategoryLink = linkType => [_net.NavigationLinkType.WhatsNewInCategory, _net.NavigationLinkType.SubCategory, _net.NavigationLinkType.AllCategory, _net.NavigationLinkType.PopularLookbook].every(type => linkType !== type);

/**
 * Get the what's new and all category links which are randomly ordered and return what's new first
 * @param subCategories
 */
exports.isNotCategoryLink = isNotCategoryLink;
const getWhatsNewAndAllCategory = subCategories => {
  const whatsNewCategory = subCategories.find(({
    linkType
  }) => linkType === _net.NavigationLinkType.WhatsNewInCategory);
  const otherCategories = subCategories.filter(({
    linkType,
    url
  }) => linkType === _net.NavigationLinkType.AllCategory && url);
  return whatsNewCategory ? [whatsNewCategory, ...otherCategories] : otherCategories;
};
exports.getWhatsNewAndAllCategory = getWhatsNewAndAllCategory;
const determineActiveCategory = activeLink => {
  if (activeLink?.linkType !== 'Gifts') {
    return Object.values(_models.Categories).find(cat => (0, _utils.stripSlashes)(activeLink?.url).endsWith(cat)) ?? '';
  }
  return 'gift-ideas';
};
exports.determineActiveCategory = determineActiveCategory;